import React from 'react';
import { useNavigate } from 'react-router-dom';

const CreateEvent: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div>
      <h1 style={{ margin: 0, fontSize: '28px', color: '#333' }}>🎉 Create Event</h1>
      <p style={{ margin: '10px 0 30px 0', color: '#666' }}>Host a personal event and invite friends</p>
      <div style={{ background: 'white', padding: 40, borderRadius: 12, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <span style={{ fontSize: 48 }}>🎉</span>
        <p style={{ color: '#666', marginTop: 15 }}>Create events from your Groups</p>
        <p style={{ color: '#999', fontSize: 14, marginTop: 8 }}>Join a group, then create events for your community</p>
        <button
          onClick={() => navigate('/groups')}
          style={{
            marginTop: 20,
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 10,
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Go to Groups
        </button>
      </div>
    </div>
  );
};

export default CreateEvent;
